import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const imgSrc = (url) => (url && url.startsWith('/') ? `${API_URL}${url}` : url);

/** Auto-hiding strip of products published in the last 14 days (fed by the Shopify webhook). */
export const NewArrivalsStrip = ({ limit = 4 }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/products/new-arrivals?limit=${limit}`)
      .then((r) => r.json())
      .then((d) => setItems(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, [limit]);

  if (items.length === 0) return null;

  return (
    <div className="mb-12" data-testid="new-arrivals-strip">
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] uppercase tracking-wider bg-white text-black font-bold">
          <Sparkles className="w-3 h-3" /> Just dropped
        </span>
        <h3 className="text-white text-xl" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>
          New Arrivals
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((p) => (
          <Link key={p.slug} to={`/shop/${p.slug}`} className="group block relative" data-testid={`new-arrival-${p.slug}`}>
            <div className="aspect-square overflow-hidden bg-zinc-900 border border-zinc-800 group-hover:border-white/40 transition-colors">
              <img src={imgSrc(p.images?.[0])} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
            </div>
            <span className="absolute top-3 left-3 px-2 py-0.5 text-[10px] uppercase tracking-wider bg-[#C7FA3E] text-black font-bold">New</span>
            <p className="text-white text-sm mt-2 truncate" style={{ fontFamily: 'Oswald, sans-serif' }}>{p.name}</p>
            <p className="text-[#C7FA3E] text-xs">${Math.round(p.price)}</p>
          </Link>
        ))}
      </div>
      <Link to="/shop" className="inline-flex items-center gap-1.5 mt-4 text-zinc-400 text-xs uppercase tracking-widest hover:text-[#C7FA3E] transition-colors" style={{ fontFamily: 'Oswald, sans-serif' }} data-testid="new-arrivals-shop-link">
        See everything <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
};
